import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DebounceDirective } from './debounce';
import { DragAndDropDirective } from './dragAndDrop';
import { NumberInputDirective } from './numberInput';
import { DateInputDirective } from './dateInput';
import { ScrollableDirective } from './scrollable';
import { SimpleAutocompleteDirective } from './simpleAutocomplete';
import { TextareaAutoheightDirective } from './textareaAutoheight';
import { InputAutowidthDirective } from './inputAutowidth';
import { CollapsibleDirective } from './collapsibleCard';
import { InitDirective } from './ngInit';
import { SimpleAutocompleteOverlayModule } from '../components/simple-autocomplete-overlay/simple-autocomplete-overlay.module';
import { InputChangeDirective } from './inputChange';

@NgModule({
  declarations: [
    DebounceDirective,
    DragAndDropDirective,
    NumberInputDirective,
    DateInputDirective,
    ScrollableDirective,
    SimpleAutocompleteDirective,
    TextareaAutoheightDirective,
    InputAutowidthDirective,
    CollapsibleDirective,
    InitDirective,
    InputChangeDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DebounceDirective,
    DragAndDropDirective,
    NumberInputDirective,
    DateInputDirective,
    ScrollableDirective,
    SimpleAutocompleteDirective,
    TextareaAutoheightDirective,
    InputAutowidthDirective,
    CollapsibleDirective,
    InitDirective,
    InputChangeDirective
  ],
  providers: [
    SimpleAutocompleteOverlayModule
  ]
})
export class DirectivesModule { }
